import { connect } from 'react-redux';
import { DashboardAction } from 'redux/actions';
import DashboardComponent from './dashboard';

const mapStateToProps = (state) => ({
    campaignAnalytics: (state.dashboard && state.dashboard.campaignAnalytics) ? state.dashboard.campaignAnalytics : [],
    transactionGraphData: (state.dashboard && state.dashboard.transactionGraphData) ? state.dashboard.transactionGraphData : [],
    activeCampaignsMap: (state.dashboard && state.dashboard.activeCampaignsMap && state.dashboard.activeCampaignsMap.regional) ? state.dashboard.activeCampaignsMap.regional : [],
    activeCampaignsLocal: (state.dashboard && state.dashboard.activeCampaignsMap && state.dashboard.activeCampaignsMap.local) ? state.dashboard.activeCampaignsMap.local : [],
    widgetSaved: (state.dashboard && state.dashboard.widgetSaved) ? state.dashboard.widgetSaved : [],
    
});
const mapDispatchToProps = (dispatch) => ({
    getCampaignAnalytics: (payload) => dispatch(DashboardAction.getCampaignAnalytics(payload)),
    getTransactionsGraphData: (payload) => dispatch(DashboardAction.getTransactionsGraphData(payload)),
    getActiveCampaignMapData: (payload) => dispatch(DashboardAction.getActiveCampaignMapData(payload)),
});

const DashboardContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(DashboardComponent);

export default DashboardContainer;
